<template>
  <v-card>
    <v-card-title class="headline">
      Lisää kuvia
    </v-card-title>
    <v-alert
      v-if="snackbar"
      outlined
      type="success"
      text
      class="mx-2"
    >
      Kuvan lähettäminen onnistui!
    </v-alert>
    <v-card-text v-else class="grey lighten-4 py-2">
      {{ this.imageData ? `Valittu: ${this.imageData.name}` : 'Ei valittua kuvaa' }}
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn @click="click1" class="ml-2">Valitse kuva</v-btn>
      <input
        type="file"
        :disabled="uploading"
        ref="input1"
        style="display: none"
        @change="previewImage"
        accept="image/*"
      />
      <v-btn
        v-if="this.imageData"
        :loading="uploading"
        dark
        color="pink"
        class="ml-2"
        @click="create"
      >
        Lähetä
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      imageData: null,
      snackbar: false,
    };
  },
  computed: {
    ...mapState({
      uploading: (state) => state.content.uploading,
    }),
  },

  methods: {
    ...mapActions('content', {
      upload: 'upload',
    }),
    create() {
      this.upload(this.imageData);
    },
    click1() {
      this.$refs.input1.click();
    },
    previewImage(event) {
      this.snackbar = false;
      [this.imageData] = event.target.files;
    },
  },

  watch: {
    uploading: {
      handler(val) {
        if (val === false) {
          this.snackbar = true;
        }
      },
    },
  },
};
</script>
